var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.343,
    height: 12.343,
    viewBox: "0 0 12.343 12.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12300",
    "data-name": "Group 12300",
    opacity: 0.887
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10900",
    "data-name": "Group 10900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37749",
    "data-name": "Path 37749",
    d: "M105.722,0V1.371h2.458L101.44,8.112l.97.97,6.741-6.741V4.8h1.371V0Z",
    transform: "translate(-98.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37750",
    "data-name": "Path 37750",
    d: "M10.972,10.972h-9.6v-9.6h4.8V0h-4.8A1.371,1.371,0,0,0,0,1.371v9.6a1.371,1.371,0,0,0,1.371,1.371h9.6a1.371,1.371,0,0,0,1.371-1.371v-4.8H10.972Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/navigator.90171649.svg";
export { ForwardRef as ReactComponent };